(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mue-product-support"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mue-product-support')) {
    customElements.define('mue-product-support', class extends HTMLElement {
      static calendarRequests = new Map();
      static addBusinessDays(start, count, holidays) {
        const date = new Date(start.getTime());
        let elapsed = 0;
        while (elapsed < count) {
          date.setUTCDate(date.getUTCDate() + 1);
          const day = date.getUTCDay();
          if (day !== 0 && day !== 6 && !holidays.has(date.toISOString().slice(0, 10))) elapsed++;
        }
        return date;
      }
      async connectedCallback() {
        const minimum = Math.max(1, Math.min(20, Number(this.dataset.deliveryMin) || 6));
        const maximum = Math.max(minimum, Math.min(20, Number(this.dataset.deliveryMax) || 9));
        const url = this.dataset.calendarUrl;
        const type = this.constructor;
        if (!type.calendarRequests.has(url)) type.calendarRequests.set(url, fetch(url).then((response) => {
          if (!response.ok) throw new Error('Calendar unavailable');
          return response.json();
        }));
        try {
          const calendar = await type.calendarRequests.get(url);
          if (!this.isConnected) return;
          const entries = Object.keys(calendar.holidays || {});
          const years = new Set(entries.map((date) => date.slice(0, 4)));
          const todayParts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
          const parts = Object.fromEntries(todayParts.map(({ type, value }) => [type, value]));
          const today = new Date(`${parts.year}-${parts.month}-${parts.day}T12:00:00Z`);
          if (!years.has(parts.year)) return;
          const holidays = new Set(entries);
          const first = type.addBusinessDays(today, minimum, holidays);
          const last = type.addBusinessDays(today, maximum, holidays);
          if (!years.has(last.toISOString().slice(0, 4))) return;
          const formatter = new Intl.DateTimeFormat(this.dataset.dateLocale || 'fr', { day: 'numeric', month: 'short', timeZone: 'UTC' });
          const start = this.querySelector('[data-delivery-start]');
          const end = this.querySelector('[data-delivery-end]');
          start.dateTime = first.toISOString().slice(0, 10);
          end.dateTime = last.toISOString().slice(0, 10);
          start.textContent = formatter.format(first);
          end.textContent = formatter.format(last);
          this.querySelector('[data-delivery-dates]').hidden = false;
        } catch {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mue-videos"] && !Shopify.designMode) return;
  try {
    (()=>{
 const initialized=new WeakSet();
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 function init(root){
  if(initialized.has(root))return;
  initialized.add(root);
  const list=root.querySelector('.mue-vidbloc__liste');
  const videos=[...root.querySelectorAll('video')];
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   const v=entry.target;v.dataset.visible=entry.isIntersecting?'true':'false';
   if(entry.isIntersecting&&!window.matchMedia('(max-width: 989px)').matches&&!reduced.matches&&!v.dataset.userPaused&&!document.hidden)play(v);else v.pause();
  }),{threshold:.4});
  function play(v){v.muted=true;v.defaultMuted=true;if(!v.src)v.src=v.dataset.src;v.play().catch(()=>{v.controls=true;});}
  function state(v){const button=v.parentElement.querySelector('button');const playing=!v.paused;v.parentElement.classList.toggle('is-playing',playing);button.setAttribute('aria-pressed',String(playing));button.setAttribute('aria-label',(playing?button.dataset.pauseLabel:button.dataset.playLabel)+' : '+v.getAttribute('aria-label'));}
  videos.forEach(v=>{v.muted=true;v.defaultMuted=true;observer.observe(v);['play','pause'].forEach(event=>v.addEventListener(event,()=>state(v)));v.addEventListener('volumechange',()=>{if(!v.muted)v.muted=true;});});
  root.addEventListener('click',event=>{
   const toggle=event.target.closest('[data-mue-video-toggle]');
   if(toggle){const v=toggle.parentElement.querySelector('video');if(v.paused){delete v.dataset.userPaused;play(v);}else{v.dataset.userPaused='true';v.pause();}}
   const direction=event.target.closest('[data-mue-video-next]')?1:event.target.closest('[data-mue-video-prev]')?-1:0;
   if(direction)list.scrollBy({left:direction*(list.querySelector('li').getBoundingClientRect().width+8),behavior:reduced.matches?'instant':'smooth'});
  });
  function arrows(){root.querySelector('.mue-vidbloc__arrows').hidden=list.scrollWidth<=list.clientWidth+2;const prev=root.querySelector('[data-mue-video-prev]'),next=root.querySelector('[data-mue-video-next]');prev.disabled=list.scrollLeft<2;next.disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-2;}
  list.addEventListener('scroll',arrows,{passive:true});new ResizeObserver(arrows).observe(list);arrows();
  document.addEventListener('visibilitychange',()=>videos.forEach(v=>{if(document.hidden)v.pause();else if(!window.matchMedia('(max-width: 989px)').matches&&v.dataset.visible==='true'&&!reduced.matches&&!v.dataset.userPaused)play(v);}));
 }
 const boot=()=>document.querySelectorAll('[data-mue-video-carousel]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',boot);
})();
  } catch(e) { console.error(e); }
})();

})();
